import WorkingAbsenceComponent from "../components/WorkingAbsence";
import useWorkingAbsence from "../hooks/useWorkingAbsence";

const WorkingAbsencePage = () => {
    const workingAbsence = useWorkingAbsence();
    return <WorkingAbsenceComponent {...workingAbsence} />;
};

export default WorkingAbsencePage;
